import { SearchOutlined } from '@ant-design/icons';
import type { InputRef } from 'antd';
import { Input } from 'antd';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { devices } from '../../const/devices';
import { useIsTablet } from '../../hooks/useBreakpoint';
import Loader from '../Loader';

const StyledSearch = styled(Input)<{ $opened: boolean }>`
	input {
		background: #f3f5f7;

		@media ${devices.tablet} {
			height: 35px;
		}
	}

	border-radius: ${props => (props.$opened ? '4px 4px 0px 0px;' : '4px 4px 4px 4px;')};

	background: #f3f5f7;
	padding-right: 1em;
`;

const ClearInput = styled.div`
	color: var(--neutral-8, #595959);
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	cursor: pointer;
`;

interface Props {
	value: string;
	isLoading: boolean;
	opened?: boolean;
	onChange: (value: string) => void;
	onFocus?: () => void;
	onCancel?: () => void;
}

const UserInputSearch: React.FC<Props> = ({ opened = false, value, isLoading, onFocus, onChange, onCancel }) => {
	// const { activeSchoolId } = useActiveSchoolId();
	const inputRef = useRef<InputRef | undefined>();
	const isTablet = useIsTablet();

	// const getUserLastSearch = trpc.userLastSearch.getUserLastSearch.useQuery({ schoolId: activeSchoolId });
	// eslint-disable-next-line no-console
	// console.log(getUserLastSearch.data);

	const downHandler = (e: any): void => {
		const { key, ctrlKey } = e;
		if (key === 'b' && ctrlKey) {
			inputRef.current?.focus();
		}
	};

	useEffect(() => {
		window.addEventListener('keydown', downHandler);
		return () => {
			window.removeEventListener('keydown', downHandler);
		};
	}, []);

	return (
		<StyledSearch
			$opened={opened}
			prefix={<SearchOutlined />}
			suffix={isLoading ? <Loader /> : value && <ClearInput onClick={onCancel}>Zrušit</ClearInput>}
			ref={r => {
				if (r) {
					inputRef.current = r;
				}
			}}
			onFocus={onFocus}
			placeholder={!isTablet ? 'Jméno, příjmení, evidenční číslo (Ctrl+B)' : 'Vyhledat žáka'}
			onChange={e => {
				onChange(e.target.value);
			}}
			value={value}
		/>
	);
};

export default UserInputSearch;
